import {faqAcd} from "./modules/faq_acd";
import {favoriteBtn} from "./modules/favorite_button";
import MatchHeight from "matchheight/dist/MatchHeight";
import {searchSlide} from "./modules/searchSlideMenu";
import {sliderSetting} from "./modules/sliderSetting";
import {spNavSwitch} from "./modules/spSlideMenu";
import {topMainImageSizing} from "./modules/top_mainImageSizing";
import {flowTab} from "./modules/flow";
import $ from "jquery";

//固定お問い合わせボタン余白
function copyrightPadding() {
    const footerCopyright = document.getElementsByClassName('footer_copyright')[0];

    if(document.getElementById('fixedContact')){
        footerCopyright.classList.add('ifIsBtn');
    } else {
        console.log('func(copyrightPadding) Message : Uncaught fixedContact')
    }
}

//固定お問い合わせボタン スクロールで出現
(function(){
    const elm = document.getElementById('fixedContact');

    function fnc(){
        if (elm){
            let scroll = window.pageYOffset;

            if (scroll > 50){
                elm.classList.add('active');
            } else {
                elm.classList.remove('active');
            }
        }
    }

    window.addEventListener('scroll',function () {
        fnc();
    })

    fnc();
}())

//メイン画像のランダム表示
$(function(){
    let ABCRundum = new Array();
    ABCRundum[0] = "#RundumA";
    ABCRundum[1] = "#RundumB";
    let n = Math.floor(Math.random()*ABCRundum.length);
    $(ABCRundum[n]).css('display','block');
});

//お問い合わせページ 確認ボタン押下時スクロール
(function () {
    const confirmBtn = document.getElementsByClassName('wpcf7c-btn-confirm')[0];
    const formBody = document.getElementsByClassName('wpcf7')[0];

    if (confirmBtn){
        confirmBtn.addEventListener('click', function () {
            let formTop = window.pageYOffset + formBody.getBoundingClientRect().top - 120;

            window.scrollTo({
                top: formTop,
                behavior: "smooth"
            });
        })
    }
}())



copyrightPadding();
faqAcd();
MatchHeight.init();
sliderSetting();
spNavSwitch();
flowTab();

//トップページのみ
if (document.getElementById('top')){
    topMainImageSizing();
}

//検索のあるページのみ
if (document.getElementById('searchSlide')){
    searchSlide();
}

//お気に入り処理のあるページのみ

if (
    document.getElementById('list') ||
    document.getElementById('detail') ||
    document.getElementById('favorite')
){
    favoriteBtn();
}